import { render, staticRenderFns } from "./SlidePages.vue?vue&type=template&id=2a6c4143&scoped=true"
import script from "./SlidePages.vue?vue&type=script&lang=js"
export * from "./SlidePages.vue?vue&type=script&lang=js"
import style0 from "./SlidePages.vue?vue&type=style&index=0&id=2a6c4143&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c4143",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6c4143')) {
      api.createRecord('2a6c4143', component.options)
    } else {
      api.reload('2a6c4143', component.options)
    }
    module.hot.accept("./SlidePages.vue?vue&type=template&id=2a6c4143&scoped=true", function () {
      api.rerender('2a6c4143', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SlidePages.vue"
export default component.exports